import { Component, OnInit } from "@angular/core";
import { AlertServiceService } from "src/app/service/alert/alert-service.service";

@Component({
  selector: "app-community-section",
  templateUrl: "./community-section.component.html",
  styleUrls: ["./community-section.component.scss"],
})
export class CommunitySectionComponent implements OnInit {
  constructor(private alert: AlertServiceService) {}
  // dashboard.huiospay.com //white label interface
  // huiospay-payment-gateway.netlify.app/  //old link

  /**payment gateway link */
  paymentGateway() {
    return window.location.assign(
      // 'https://dashboard.huiospay.com' //old link
      "https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16",
    );
  }

  ngOnInit(): void {}
}
